module.exports = __webpack_public_path__ + "img/chaussons.7d50ea06.jpg";